import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "survey-plus_gradient px-10" }
const _hoisted_2 = { class: "z-index-1 d-flex justify-content-between align-items-center position-relative py-5" }
const _hoisted_3 = { class: "d-flex z-index-1" }
const _hoisted_4 = { class: "d-md-inline" }
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_6 = {
  key: 1,
  class: "fas fa-download fs-5 ms-5"
}
const _hoisted_7 = { class: "d-md-inline" }
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_9 = {
  key: 1,
  class: "fas fa-download fs-5 ms-5"
}
const _hoisted_10 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_create_account_stepper",
  ref: "verticalWizardRef"
}
const _hoisted_11 = { class: "d-flex flex-row-fluid bg-white rounded me-9" }
const _hoisted_12 = ["validation-schema"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "text-center my-20"
}
const _hoisted_15 = { class: "d-flex flex-stack pt-10" }
const _hoisted_16 = { class: "mr-2" }
const _hoisted_17 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_18 = { class: "mr-2" }
const _hoisted_19 = { class: "indicator-label" }
const _hoisted_20 = { class: "indicator-progress" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "svg-icon svg-icon-4 ms-1 me-0" }
const _hoisted_23 = {
  key: 2,
  class: "pt-3"
}
const _hoisted_24 = { class: "text-danger" }
const _hoisted_25 = { class: "d-flex justify-content-center bg-white rounded justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px" }
const _hoisted_26 = { class: "px-6 px-lg-10 px-xxl-15 py-20" }
const _hoisted_27 = { class: "stepper-nav" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "stepper-check fas fa-check"
}
const _hoisted_30 = {
  key: 1,
  class: "stepper-number"
}
const _hoisted_31 = { class: "stepper-label" }
const _hoisted_32 = { class: "stepper-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SurveyPlusStep = _resolveComponent("SurveyPlusStep")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_survery_plus_structure = _resolveComponent("survery-plus-structure")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!
  const _component_survey_plus_summary = _resolveComponent("survey-plus-summary")!
  const _component_SurveyConfirmModal = _resolveComponent("SurveyConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createStaticVNode("<img src=\"/media/logos/logo_background_3.png\" alt=\"Logo background\" class=\"logo_background h-100\"><img src=\"/media/logos/logo_background_4.png\" alt=\"Logo background\" class=\"logo_background_1 h-100\"><div class=\"d-flex align-items-center z-index-1\"><img src=\"/media/logos/plus_logo.png\" alt=\"\" class=\"h-50px me-5\"><h1 class=\"mt-3\">INCLUSION PLUS</h1></div>", 3)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-dark-blue me-5",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printResult && _ctx.printResult(...args)))
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.translate("SURVEY_BUTTON_DOWNLOAD_EMPTY_SURVEY")) + " ", 1),
              (_ctx.surveyStructureDownloadLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                : (_openBlock(), _createElementBlock("i", _hoisted_6))
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-dark-blue",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.printSummary && _ctx.printSummary(...args)))
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.translate("SURVEY_BUTTON_DOWNLOAD_SURVEY_WITH_DATA")) + " ", 1),
              (_ctx.surveySummaryDownloadLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                : (_openBlock(), _createElementBlock("i", _hoisted_9))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("form", {
          "validation-schema": _ctx.currentFormData,
          class: "py-20 w-100 px-9",
          onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
        }, [
          (!_ctx.surveyPlusQuestionsLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getQuestionByStep(), (question) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: question.id
                  }, [
                    (question.attributes.area.data.id == _ctx.$route.params.step)
                      ? (_openBlock(), _createBlock(_component_SurveyPlusStep, {
                          key: 0,
                          question: question,
                          "disable-step": !_ctx.isCompleted && _ctx.$route.params.step > _ctx.activeSetId,
                          "on-change": _ctx.onChange
                        }, null, 8, ["question", "disable-step", "on-change"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("span", { class: "spinner-border spinner-border-lg align-middle ms-2" }, null, -1)
              ]))])),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_ctx.$route.params.step != 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-lg btn-dark-blue me-3",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, {
                        src: "/media/icons/duotune/arrows/arr063.svg",
                        "aria-hidden": "true"
                      })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate("SURVEY_GO_BEHIND_BUTTON")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.$route.params.step != _ctx.totalSteps)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "submit",
                    class: "btn btn-lg btn-dark-blue me-3",
                    onClick: _cache[3] || (_cache[3] = () => (_ctx.isLastSubmit = false))
                  }, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
                      _createElementVNode("i", { class: "fas fa-save" })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate("SURVEY_SAVE_AND_CONTINUE_BUTTON")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-lg btn-dark-blue me-3",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formSubmit()))
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
                      _createElementVNode("i", { class: "fas fa-save" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate("SURVEY_LAST_SET_SUBMIT_BUTTON")), 1),
                    _createElementVNode("span", _hoisted_20, [
                      _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-dark-blue",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.translate("CONTINUE")) + " ", 1),
                _createElementVNode("span", _hoisted_22, [
                  _createVNode(_component_inline_svg, {
                    src: "/media/icons/duotune/arrows/arr064.svg",
                    "aria-hidden": "true"
                  })
                ])
              ])
            ])
          ]),
          (Object.keys(_ctx.errors).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("small", _hoisted_24, _toDisplayString(_ctx.translate("SURVEY_ERROR_MESSAGE")), 1)
              ]))
            : _createCommentVNode("", true)
        ], 40, _hoisted_12)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveyPlusStepList, (step) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["stepper-item", _ctx.getStepClass(_ctx.bullets, step.id)]),
                "data-kt-stepper-element": "nav",
                key: step.id
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "stepper-line w-40px" }, null, -1)),
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  onClick: ($event: any) => (_ctx.validationNavigate(step.id)),
                  class: "p-5 stepper-icon w-40px h-40px"
                }, [
                  (step.id !== parseInt(_ctx.$route.params.step) && _ctx.bullets[step.id - 1])
                    ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(step.id), 1))
                ], 8, _hoisted_28),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, _toDisplayString(step["attributes"][_ctx.translateKey("description")]), 1)
                ])
              ], 2))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_vue3_html2pdf, {
        "show-layout": false,
        "float-layout": true,
        "enable-download": true,
        "preview-modal": false,
        filename: "survey structure",
        "pdf-quality": 2,
        "manual-pagination": true,
        "pdf-format": "a4",
        "pdf-orientation": "portrait",
        "pdf-content-width": "100%",
        onProgress: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onProgress($event))),
        "html-to-pdf-options": _ctx.pdfOptionsForSurveyStructure,
        ref: "html2Pdf"
      }, {
        "pdf-content": _withCtx(() => [
          _createVNode(_component_survery_plus_structure)
        ]),
        _: 1
      }, 8, ["html-to-pdf-options"]),
      _createVNode(_component_vue3_html2pdf, {
        "show-layout": false,
        "float-layout": true,
        "enable-download": true,
        "preview-modal": false,
        filename: "survey summary",
        "pdf-quality": 2,
        "manual-pagination": true,
        "pdf-format": "a4",
        "pdf-orientation": "portrait",
        "pdf-content-width": "100%",
        onProgress: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onPrintSummaryProgress($event))),
        "html-to-pdf-options": _ctx.pdfOptionsForSurveyStructure,
        ref: "html2PdfSummary"
      }, {
        "pdf-content": _withCtx(() => [
          _createVNode(_component_survey_plus_summary, { isSummary: true })
        ]),
        _: 1
      }, 8, ["html-to-pdf-options"]),
      _createVNode(_component_SurveyConfirmModal, {
        ref: "surveyConfirmModalRef",
        submitSurveyInput: _ctx.submitSurveyInput
      }, null, 8, ["submitSurveyInput"])
    ], 512)
  ], 64))
}